export default "__VITE_ASSET__CmEc9_dA__"